import React from 'react';

interface DividerProps {
  className?: string;
  label?: string;
  variant?: 'solid' | 'dashed' | 'dotted';
}

export const Divider: React.FC<DividerProps> = ({ className = '', label, variant = 'solid' }) => {
  const borderClass =
    variant === 'dashed' ? 'border-bottom-dashed' : variant === 'dotted' ? 'border-bottom-dotted' : 'border-bottom';

  if (label) {
    return (
      <div className={`d-flex align-items-center ${className}`}>
        <div className={`flex-grow-1 ${borderClass} border-gray-300`}></div>
        <span className="px-3 text-gray-600">{label}</span>
        <div className={`flex-grow-1 ${borderClass} border-gray-300`}></div>
      </div>
    );
  }

  return <div className={`${borderClass} border-gray-300 ${className}`}></div>;
};
